import { Component, OnInit, ViewChild } from "@angular/core";
import { Constant } from "../core/constant";
import { AdminService } from "../services/admin.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { MatMenuTrigger } from "@angular/material/menu";
import { Router } from "@angular/router";
import { CategoryList } from "../models/category-list";
import { Category } from "../models/category";

@Component({
  selector: "app-view-all-category-list",
  templateUrl: "./view-all-category-list.component.html",
  styleUrls: ["./view-all-category-list.component.scss"],
})
export class ViewAllCategoryListComponent implements OnInit {
  loading: boolean = false;
  pageSizes: any[] = Constant.PageSizes;
  searchKey: string;

  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;

  categoryList: CategoryList = new CategoryList();
  error: string = "";
  modalOption: NgbModalOptions = {};
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;

  constructor(
    private adminService: AdminService,
    private ngbModal: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.getCategoryList();
  }

  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.getCategoryList();
  }

  getCategoryList(): void {
    this.loading = true;
    this.adminService
      .GetCategoryList(
        (this.page - 1) * this.pageSize,
        this.pageSize,
        this.searchKey
      )
      .subscribe((data: CategoryList) => {
        this.categoryList.categories = data.categories.map(
          (o) => new Category(o)
        );
        this.collectionSize = data.count;
        this.loading = false;
        (error: string) => {
          this.error = error;
          const modalRef = this.ngbModal.open(FailModuleComponent);
          this.error = error;
          modalRef.componentInstance.errorMessage = error;
          this.loading = false;
        };
      });
  }

  addSearchKey(searchKey) {
    this.searchKey = searchKey.value;
    this.page = 1;
    this.getCategoryList();
  }

  onAddEditCategory(categoryId: number = null) {
    if (!categoryId) {
      this.router.navigate(["/add-category"]);
    } else {
      this.router.navigate(["/add-category/" + categoryId]);
    }
  }

  closeMatMenuAndOpenDeleteModal(item, event) {
    this.trigger.closeMenu();
    setTimeout(() => {
      this.openDeleteModal(item, event);
    }, 100);
  }

  openDeleteModal(item, event) {
    //debugger;
    event.stopPropagation();
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title =
      "Do you want to remove this Category from the list? ";
    modalRef.componentInstance.deleteItem = item;
    modalRef.componentInstance.message =
      "All the dependencies will be removed along with this Category";
    this.trigger.closeMenu();
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItem) => {
      //debugger;
      if (deleteItem != null) {
        let category = new Category(item);
        this.loading = true;
        this.adminService.DeleteCategory(category).subscribe((data: any) => {
          this.loading = false;
          this.page = 1;
          this.getCategoryList();
        });
      }
      this.ngbModal.dismissAll();
    });
  }
}
